var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.345,
    height: 16.394,
    viewBox: "0 0 14.345 16.394",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Delete",
    d: "M8.581,13.32H9.35a.384.384,0,0,0,.384-.384V6.02a.384.384,0,0,0-.384-.384H8.581A.384.384,0,0,0,8.2,6.02v6.916A.384.384,0,0,0,8.581,13.32ZM13.832,2.562H11.194L10.105.746A1.537,1.537,0,0,0,8.786,0H5.558A1.537,1.537,0,0,0,4.24.746L3.151,2.562H.512A.512.512,0,0,0,0,3.074v.512A.512.512,0,0,0,.512,4.1h.512V14.857a1.537,1.537,0,0,0,1.537,1.537h9.222a1.537,1.537,0,0,0,1.537-1.537V4.1h.512a.512.512,0,0,0,.512-.512V3.074A.512.512,0,0,0,13.832,2.562ZM5.5,1.63a.192.192,0,0,1,.165-.093h3.01a.192.192,0,0,1,.165.093l.559.931H4.943Zm6.281,13.227H2.562V4.1h9.222ZM5,13.32h.768a.384.384,0,0,0,.384-.384V6.02a.384.384,0,0,0-.384-.384H5a.384.384,0,0,0-.384.384v6.916A.384.384,0,0,0,5,13.32Z",
    transform: "translate(0 0)",
    fill: "#00529f"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/Delete.55fb19069b52fd84df31621920d57fb2.svg";
export { ForwardRef as ReactComponent };